/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import apiService from './index'

const BASE = `${process.env.REACT_APP_BACKEND_URL_V3}/announcements`

export const getActiveAnnouncements = async () => {
  return apiService.get(`${BASE}/active`)
}

export const dismissAnnouncement = async (id: string) => {
  return apiService.post(`${BASE}/${id}/dismiss`, {})
}
